import { createMongoAbility } from '@casl/ability'
import { unpackRules } from '@casl/ability/extra'

import type { AppAbility } from './generated/abilities.generated'
import type { PackRule } from './types/contract'

/**
 * The fail-closed starting point: an ability with no rules denies everything.
 * Unknown or unloaded state must always deny.
 */
export const createEmptyAbility = (): AppAbility => createMongoAbility<AppAbility>([])

/**
 * Replace an ability's rules from the wire form.
 *
 * The wire carries CASL's own pack format — positional `[action, subject]` pairs
 * — so `unpackRules` is the right reader even though the contract only ever uses
 * the first two slots. Keeping CASL's helper here means the day the contract does
 * grow conditions, this file needs no change.
 */
export const applyPackedRules = (ability: AppAbility, rules: PackRule[]): void => {
  const unpacked = unpackRules(rules as Parameters<typeof unpackRules>[0])
  ability.update(unpacked as Parameters<AppAbility['update']>[0])
}
